<template>
  <div>
    <v-btn-toggle
      :style="fileUrlUploaded ? 'border: 1px solid #bbb' : ''"
      style="border-radius: 60px; overflow: hidden"
    >
      <v-btn
        depressed
        round
        dark
        color="secondary"
        v-if="!fileUrlUploaded && !uploading"
        @click.native="selectFile"
      >
        <v-icon color="white" class="mr-1" left>attach_file</v-icon>
        <span class="white--text pr-2">{{
          label ? label : $t('common.UploadFile')
        }}</span>
      </v-btn>
      <v-btn
        depressed
        round
        dark
        flat
        v-if="fileUrlUploaded"
        @click="showFile()"
      >
        <span class="pl-2">{{ shortName }}</span>
      </v-btn>
      <v-btn
        flat
        class="error v-btn--active"
        v-if="fileUrlUploaded"
        @click="deleteImage()"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </v-btn-toggle>
    <input
      :accept="acceptedType"
      id="files"
      type="file"
      ref="uploadInput"
      :multiple="false"
      @change="detectFiles($event)"
    />
    <v-progress-circular
      v-if="uploading && !fileUrlUploaded"
      :size="36"
      :width="5"
      :rotate="360"
      :value="progressUpload"
      color="primary"
      >%</v-progress-circular
    >
  </div>
</template>

<script>
import firebase from '@firebase/app'
import '@firebase/storage'
import '@firebase/firestore'

export default {
  props: {
    pathToFiles: {
      type: String,
      required: false
    },
    fileUrlUploaded: {
      type: String,
      default: ''
    },
    fileNameUploaded: {
      type: String,
      default: ''
    },
    acceptedType: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      progressUpload: 0,
      fileName: '',
      uploadTask: '',
      uploading: false,
      truncateLength: 20
    }
  },
  computed: {
    shortName() {
      if (this.fileNameUploaded.length > this.truncateLength)
        return (
          this.fileNameUploaded.substring(0, this.truncateLength - 8) +
          '...' +
          this.fileNameUploaded.substring(this.fileNameUploaded.length - 5)
        )
      return this.fileNameUploaded
    }
  },
  methods: {
    showFile() {
      window.open(this.fileUrlUploaded, '_blank')
    },
    selectFile() {
      this.$refs.uploadInput.click()
    },
    detectFiles(e) {
      let fileList = e.target.files || e.dataTransfer.files
      Array.from(Array(fileList.length).keys()).map(f => {
        this.upload(fileList[f])
      })
    },
    upload(file) {
      const storage = firebase.storage()
      //this.fileNameUploaded = file.name;
      this.$emit('update:fileNameUploaded', file.name)
      this.uploading = true
      this.uploadTask = storage
        .ref(this.pathToFiles + '/' + file.name)
        .put(file)
    },
    deleteImage() {
      const storage = firebase.storage()
      storage
        .ref(this.pathToFiles + '/' + this.fileNameUploaded)
        .delete()
        .then(() => {
          this.uploading = false
          //this.fileUrlUploaded = "";
          this.$refs.uploadInput.value = ''
          this.$emit('update:fileUrlUploaded', '')
          this.$emit('fileRemoved')
        })
        .catch(error => {
          window.console.error(`file delete error occured: ${error}`)
        })
    }
  },
  watch: {
    uploadTask: function () {
      this.uploadTask.on(
        'state_changed',
        sp => {
          this.progressUpload = Math.floor(
            (sp.bytesTransferred / sp.totalBytes) * 100
          )
        },
        null,
        () => {
          this.uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
            //this.fileUrlUploaded = downloadURL;
            this.$emit('update:fileUrlUploaded', downloadURL)
            this.$emit('uploadComplete', downloadURL, this.fileNameUploaded)
          })
        }
      )
    }
  }
}
</script>

<style>
input[type='file'] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
}
</style>
